import { useEffect, useRef, useState } from 'react';
import { postData } from '../../ApiServices/ApiService';
import { ORG_DISBURSEMENT_LIST_FILTER,ORG_EXPENSE_LIST_FILTER,ORG_EXPENSE_EDIT_DEL_APPROVE} from '../../ApiServices/BaseURL';
import { logFrontendException } from '../../Utils/Exception';
import { useTheme } from '../../GlobalContext/GlobalContext';

const DisbursementsListController = (disbursementList, onRefresh,setDisbursementList,setDisbursementLoading,setDisbursementError,fetchDisbursementList) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [requestModalError,setRequestModalError] = useState('')
  const [disbursementFilteredList, setDisbursementFilteredList] = useState(disbursementList || []);
  const { setIsLoginPopup } = useTheme();
  const [filters, setFilters] = useState({
    approvedDate:"",
    date: "",
    amount: "",
    status: null,
    emp_id: null,

});
  const pageName = "DisbursementListController";
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
  const [filterError, setFilterError] = useState('');
  const [deleteLoading, setDeleteLoading] = useState({});
  const [deleteError, setDeleteError] = useState({});
  const [deleteSuccess, setDeleteSuccess] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const expenseDeleteRef = useRef(null);

  const expenseInfoRef = useRef(null);

  const dropdownRefs = useRef({});
  const [openDropdown, setOpenDropdown] = useState(null);
  const statusOptions = [,
    { label: 'Available', value: 1},
    { label: 'Partially Approved', value: 4 },
    { label: 'Request Approved', value: 3 },
    { label: 'Request pending', value: 2},
    { label: 'Rejected',value:5}
  ];

  useEffect(() => {
    if (disbursementList) {
      setDisbursementFilteredList(disbursementList)
    }
  }, [disbursementList]);

  const handleChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
    setFilterError('');
  };

      useEffect(() => {
          const handleClickOutside = (event) => {
              const isOutside = Object.keys(dropdownRefs.current).every(
                  (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
              );
              if (isOutside) {
                  setOpenDropdown(null);
              }
          };
          document.addEventListener("mousedown", handleClickOutside);
          return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  const fetchFilterExpensesList = async () => {
    // setExpenseFilterdList([])
    setLoading(true);
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payload = {
        "action_code": "Expense_Filter",
        "emp_id_auth": storedUserInfo?.emp_id,
        "expense_date": filters?.expenseDate || "",
        "approved_date": filters?.approvedDate || "",
        "expense_status": filters?.status?.value || 0,
        "amount": filters?.amount || 0,
      }
      const response = await postData(ORG_EXPENSE_LIST_FILTER, payload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            // setExpenseFilterdList(responseData?.dataJ || []);
            setCurrentPage(1);
          } else {
            setFilterError(responseData?.info || "Failed to fetch expenses.");
            //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, "fetchFilterExpensesList", responseData || '');

          }
        } else {
          setFilterError(responseData?.info || "Failed to fetch expenses.");
          //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchFilterExpensesList", responseData || '');
        }
      }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setFilterError('Unauthorized access. Your session may have expired. Please log in again.');
            setIsLoginPopup(true)
        //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchFilterExpensesList", responseData || response || '');
               
        } else {
        setFilterError(responseData?.info || "Failed to fetch expenses.");
        //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchFilterExpensesList", responseData || response || '');
      }
    } catch (err) {
      setFilterError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchFilterExpensesList-catch", err || '');
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    const isAnyFilterApplied = Object.values(filters).some(
      (val) => val !== null && val !== undefined && String(val).trim() !== ""
    );

    if (!isAnyFilterApplied) {
      setFilterError("Please apply at least one filter to proceed.");
      return;
    }

    setFilterError("");
    fetchFilterExpensesList();
  };

  // Pagination logic
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(disbursementFilteredList.length / itemsPerPage);

  const currentDisbursements = disbursementFilteredList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getVisiblePages = () => {
    const maxPages = 3;
    const start = Math.max(1, currentPage - 1);
    const end = Math.min(totalPages, start + maxPages - 1);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const visiblePages = getVisiblePages();


  const getStatusStyle = (approval_status_name) => {
    const status = approval_status_name?.toLowerCase();
    switch (status) {
      case "available":
        return { backgroundColor: "#fff3cd", color: "#DFA510" };
      case "rejected":
        return { backgroundColor: "#C7C4C32E", color: "#7B7B7B" }; // Gray
      case "request pending":
        return { backgroundColor: "#EE201C2E", color: "#EE201C" };
      case "partially approved":
        return { backgroundColor: "#fff3cd", color: "#DFA510" }; // Yellow
      case "request approved":
        return { backgroundColor: "#1A932E2E", color: "#1A932E" };
  
      // return { backgroundColor: "#E65F2B2E", color: "#E65F2B" };
      default:
        return {};
    }
  };

  const openModal = ()=>{
    expenseInfoRef.current = null;
    console.log('disbursementData:-',disbursementData)
    setRequestModalError('')
    if(!disbursementData){
      setRequestModalError('Please select check the any one in the list');return
    }
    setShowModal(true);
  }

  const handleEditService = (expenseData) => {
    expenseInfoRef.current = {
      ...expenseData,
      pageType: 'edit'
    };
    setShowModal(true);
  }

  const handleViewService = (expenseData) => {
    expenseInfoRef.current = {
      ...expenseData,
      pageType: 'view'
    };
    setShowModal(true);
  }

  const onExpenseDelete = async (expenseInfo) => {;
    expenseDeleteRef.current = expenseInfo;
    setIsDeleteModalOpen(true);

  }

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false); // Close the modal
  }

  const callDeleteExpense = async (expense) => {
      try {
        // console.log('expense:-',expense);return
        const expenseIds = expense.expenses.map(e => e.id);
        setDeleteError({});
        setDeleteError((prev) => ({ ...prev, [expense?.expenses[0]?.id]: ''}));
        setDeleteLoading((prev) => ({ ...prev, [expense?.expenses[0]?.id]: true }));
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        const payLoad = {
          "action":"delete",
          "emp_id_auth": storedUserInfo?.emp_id,
          "expense_ids": expenseIds
        }
    
        // Make the API call
        const response = await postData(ORG_EXPENSE_EDIT_DEL_APPROVE,payLoad);
        const responseData = await response.json();
    
        // Check for success (200) and internal status code
        if (response?.status === 200) {
          if (responseData?.status_code === 200) {
            if (responseData?.message.toLowerCase() === 'success') {
              setDeleteSuccess((prev) => ({ ...prev, [expense?.expenses[0]?.id]: responseData?.info}));
              setTimeout(() => {
                onRefresh();
                setDeleteSuccess((prev) => ({ ...prev, [expense?.expenses[0]?.id]: ''}));
                setCurrentPage(1);
              }, 3000);
            } else {
              setDeleteError((prev) => ({ ...prev, [expense?.expenses[0]?.id]: responseData?.info || 'Failed to delete expense. Please try again.'}));
              //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
              logFrontendException(storedUserId, pageName, `callDeleteExpense-${expense?.expenses[0]?.id}`, responseData?.info || '');
            }
          } else {
            setDeleteError((prev) => ({ ...prev, [expense?.expenses[0]?.id]: responseData?.info || 'Failed to delete expense. Please try again...'}));
            //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException(storedUserId, pageName, `callDeleteExpense-${expense?.expenses[0]?.id}`, responseData?.info || responseData || '');
          }
        }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
           setDeleteError((prev) => ({ ...prev, [expense?.expenses[0]?.id]: 'Unauthorized access. Your session may have expired. Please log in again.'}));
            //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, `callDeleteExpense-${expense?.expenses[0]?.id}`, response || '');
          setIsLoginPopup(true)    
          } else {
          setDeleteError((prev) => ({ ...prev, [expense?.expenses[0]?.id]: 'Unexpected error occurred. Please try again later.'}));
          //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, `callDeleteExpense-${expense?.expenses[0]?.id}`, response || '');
        }
      } catch (error) {
          setDeleteError((prev) => ({ ...prev, [expense?.expenses[0]?.id]: `Failed to delete expense data. Please check your network connection and try again.` }));
          //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, `callDeleteExpense-${expense?.expenses[0]?.id}`, error || '');
       
      } finally {
          setDeleteLoading((prev) => ({ ...prev, [expense?.expenses[0]?.id]: false })); 
      }
    }
    const [disbursementData, setDisbursementData] = useState(null)
    const handleApproveReject = (item) => {
      setRequestModalError('')
        setDisbursementData(item)
        console.log("Handle Approve/Reject", item);
      };
  


      const applyFiltersDisbursementList = async () => {
        console.log("filters1", filters)
          setFilterError(""); // Clear any previous error
          setDisbursementError('');
          const { employee, ...restFilters } = filters;
      
          const isAnyFilterApplied = Object.values(restFilters).some(
            (val) => val !== null && val !== undefined && String(val).trim() !== ""
          );
        
          if (!isAnyFilterApplied) {
            setFilterError("Please apply at least one filter to proceed.");
            return;
          }
        
          setDisbursementFilteredList([]);
          setLoading(true);
          setCurrentPage(1);
          try {
            const payload = {
              emp_id_auth: storedUserId,
              action_code: "disbursement_filter",
              employee_id: filters.emp_id || null,
              expense_date: filters.date || null,
              approved_date: filters.approvedDate || null,
              amount: filters.amount || null,
              status: filters.status?.value ?? null
            };
            
            console.log("payload in Disbursements List flter", payload)
            // return
            const response = await postData(ORG_DISBURSEMENT_LIST_FILTER, payload);
            const responseData = await response.json();
            if (response.status === 200 && responseData.status_code === 200) {
              if (responseData.status_code === 200) {
                if (responseData.message.toLowerCase() === "success") {
                if (responseData?.dataJ?.length > 0) {
                  setDisbursementFilteredList(responseData?.dataJ || []);
                } else {
                  setDisbursementError(responseData?.info || "No disbursement list available.");
                  //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
                  logFrontendException(storedUserId, pageName, "applyFiltersDisbursementList", responseData?.info);
                }
                } else {
                setDisbursementError(responseData?.info || "Failed to fetch disbursement list.");
                //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException(storedUserId, pageName, "applyFiltersDisbursementList", responseData?.info || '');
                }
              } else {
                setDisbursementError("Failed to fetch disbursement list. Please try again.");
                //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException(storedUserId, pageName, "applyFiltersDisbursementList", responseData);
              }
            } else {
              setDisbursementError(responseData?.info || "Failed to fetch disbursement.");
              logFrontendException(storedUserId, pageName, "applyFiltersDisbursementList", response || '');
            }
          } catch (err) {
            setDisbursementError("Network error. Please try again.");
            logFrontendException(storedUserId, pageName, "applyFiltersDisbursementList-catch", err || '');
          } finally {
            setLoading(false);
          }
        };
      
        const resetFilters = () => {
          setFilterError('')
          setFilters({ employee: "", date: "", amount: "", status: null, emp_id: null, });
          fetchDisbursementList();
        };    
  return {
    showModal,
    openModal,
    disbursementData,
    handleApproveReject,
    closeModal: () => {setShowModal(false);setDisbursementData(null)},
    handleAddExpense:()=> onRefresh(),
    filters,
    setFilters,
    handleChange,
    statusOptions,
    openDropdown,
    toggleDropdown,
    dropdownRefs,
    applyFilters,
    resetFilters,
    loading,
    disbursementFilteredList: currentDisbursements,
    filterError,
    setFilterError,
    currentPage,
    totalPages,
    handlePageChange,handleViewService,
    deleteLoading,expenseInfoRef,
    visiblePages, getStatusStyle, handleEditService, onExpenseDelete,
    deleteError, deleteSuccess,
    isDeleteModalOpen, handleCloseDeleteModal,
    callDeleteExpense,expenseDeleteRef,
    applyFiltersDisbursementList,requestModalError  
  };
};

export default DisbursementsListController;
